export enum AppInitStatus {
	Done = "Done",
	InProgress = "AIR Uploader is initializing",
	Failed = "An error occurred during application initialization. Try to re-sign into the app",
}
